<div class="confidence-metric-card bg-gray-100 rounded p-3.5">
  <!-- Header with label, value and info icon -->
  <div class="flex items-start justify-between mb-2">
    <div class="flex items-center gap-2 mb-2">
      <div class="b1 text-gray-800">{{ label }}:</div>
      <div class="b2" [ngClass]="valueTextColor">
        {{ metric.formattedValue }}
      </div>
    </div>
    <m-tooltip
      [content]="tooltipContentTemplate"
      position="top"
      [tooltipOptions]="{
        appendTo: 'body',
        positionTop: -12,
        positionLeft: 4,
        showDelay: 0,
        tooltipStyleClass: 'm-tooltip metric-tooltip',
      }">
      <span
        class="material-symbols-outlined text-gray-500 icon-small cursor-pointer">
        info
      </span>
    </m-tooltip>
  </div>

  <!-- Progress bar -->
  <div class="progress-bar-container">
    <div class="progress-bar" [ngClass]="progressBarClasses">
      <!-- Tick marker -->
      <div class="tick-marker" [style.left.%]="tickPosition"></div>
    </div>
  </div>

  <!-- Labels below progress bar -->
  <div class="progress-labels">
    @if (showMinRangeLabel) {
      <span
        class="c1 text-gray-800 absolute"
        [style.left.%]="startLabelPosition"
        [style.transform]="startLabelPosition > 0 ? 'translateX(-50%)' : ''"
        >{{ startLabel }}
      </span>
    }

    <span
      class="c1 text-gray-800 absolute"
      [style.left.%]="middleLabelPosition"
      [style.transform]="'translateX(-50%)'">
      {{ middleLabel }}
    </span>

    @if (showMaxRangeLabel) {
      <span
        class="c1 text-gray-800 absolute"
        [style.left.%]="endLabelPosition"
        [style.transform]="'translateX(-100%)'"
        >{{ endLabel }}
      </span>
    }
  </div>
</div>

<!-- Tooltip template -->
<ng-template #tooltipContentTemplate>
  <div class="flex flex-col">
    <div
      class="b1 text-gray-500 border-b border-gray-900 pb-[12px]"
      style="border-bottom-style: solid">
      {{ tooltipTitle }}
    </div>
    <div
      class="b1 text-gray-000 border-b border-gray-900 py-[12px]"
      style="border-bottom-style: solid">
      {{ tooltipContent }}
    </div>
    <div class="c1 text-gray-500 pt-[12px]">
      {{ tooltipDescription }}
    </div>
  </div>
</ng-template>
